import { first } from 'rxjs/operators';
import html2canvas from 'html2canvas';
import {HousekeepingReport} from '@app/_components/housekeeping-report/housekeeping-report';
import {HousekeepingReportService} from '@app/_components/housekeeping-report/housekeeping-report.service';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import * as moment from 'moment/moment';

@Component({
    selector: 'app-housekeeping-report-list',
    templateUrl: './housekeeping-report-list.component.html',
    styleUrls: ['./housekeeping-report-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class HousekeepingReportListComponent implements OnInit {
	@ViewChild('pt') table: any;
	@ViewChild('exportButton') exportButton: ElementRef;

	constructor(
		private housekeepingReportService: HousekeepingReportService,
		private alertService: AlertService,
    private formBuilder: UntypedFormBuilder,
    private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private cdr: ChangeDetectorRef,
	) {
		this.statuses = housekeepingReportService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = false;
	@Input() outlineNewButton = true;
	housekeepingReports: any;
	housekeepingReport: HousekeepingReport;

  form1: UntypedFormGroup;


  // paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];
  advanceSearchData: any = [];
  advanceSearchDataFilter: LazyLoadEvent = {};
  eventFilter: LazyLoadEvent = {};
  minDate: any = new Date();


  // forms
  formLoading = false;
  isPrintMode = false;
	exportLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'housekeepingReportId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
	];

	/*********
	 * Delete Button
	 *
	 */
  defaultStartDate: Date = new Date();
  defaultEndDate: Date = new Date();
  currentSearchForm: any;

	ngOnInit(): void {
    this.formBuild();
    try {
			// default sort of list
			this.multiSortMeta = [];
      this.multiSortMeta.push({ field: 'checkInDateTime', order: 0 });
      this.multiSortMeta.push({ field: 'shortTermRentalVO.developmentVO.addressDevelopmentName', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

  formBuild() {
    this.form1 = this.formBuilder.group({
      startDate: [],
      endDate: []
    });
  }

	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

      if (event.filters && Object.keys(event.filters).length > 0)
      {
        this.eventFilter = event.filters;
      }
      this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);
      if (!this.lazyLoadEvent.filters['startDate']){
        this.lazyLoadEvent.filters['startDate'] = {'value': moment(this.defaultStartDate).format('MM/DD/YYYY'), 'matchMode': 'in'};
        this.lazyLoadEvent.filters['endDate'] = {'value': moment(this.defaultEndDate).format('MM/DD/YYYY'), 'matchMode': 'in'};

      }

      /*
      *
      * Default Sort
      */
			// https://stackoverflow.com/questions/679915/how-do-i-housekeepingReport-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.housekeepingReportService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.housekeepingReports = res.data.housekeepingReports;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
            this.loading = false;
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.housekeepingReports = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
      this.loading = false;
		}
	}


	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.housekeepingReports ? this.first === (this.housekeepingReports.length - this.rows) : true; }
	isFirstPage(): boolean { return this.housekeepingReports ? this.first === 0 : true; }


	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

  onDateChange()
  {
    if (this.form1.get('startDate').value) {
      this.minDate = this.form1.get('startDate').value;
    }
  }

  onSearchSubmit(searchForm: any) {
      this.currentSearchForm = searchForm;

    this.advanceSearchDataFilter.filters = {};
    if (this.currentSearchForm.startDate && this.currentSearchForm.endDate) {
      this.lazyLoadEvent.filters['startDate'] = {'value': moment(this.currentSearchForm.startDate).format('MM/DD/YYYY'), 'matchMode': 'in'};
      this.lazyLoadEvent.filters['endDate'] = {'value': moment(this.currentSearchForm.endDate).format('MM/DD/YYYY'), 'matchMode': 'in'};
    }else{
      this.advanceSearchDataFilter.filters = {};
      delete this.lazyLoadEvent.filters['startDate'];
      delete this.lazyLoadEvent.filters['endDate'];
    }
    if (this.currentSearchForm.developmentIdList && this.currentSearchForm.developmentIdList.length > 0){
      this.lazyLoadEvent.filters['shortTermRentalVO.developmentVO.developmentId'] = {'value': this.currentSearchForm.developmentIdList, 'matchMode': 'in'};
    }else{
      delete this.lazyLoadEvent.filters['shortTermRentalVO.developmentVO.developmentId'];
    }
    if (this.currentSearchForm.shortTermRentalIdList && this.currentSearchForm.shortTermRentalIdList.length > 0){
      this.lazyLoadEvent.filters['shortTermRentalVO.shortTermRentalId'] = {'value': this.currentSearchForm.shortTermRentalIdList, 'matchMode': 'in'};
    }else{
      delete this.lazyLoadEvent.filters['shortTermRentalVO.shortTermRentalId'];
    }

    if (this.currentSearchForm.locationIdList && this.currentSearchForm.locationIdList.length > 0){
      this.lazyLoadEvent.filters['shortTermRentalVO.locationId'] = {'value': this.currentSearchForm.locationIdList, 'matchMode': 'in'};
    }else{
      delete this.lazyLoadEvent.filters['shortTermRentalVO.locationId'];
    }

    if (this.currentSearchForm.reservationStatusList && this.currentSearchForm.reservationStatusList.length > 0){
      this.lazyLoadEvent.filters['reservationStatus'] = {'value': this.currentSearchForm.reservationStatusList, 'matchMode': 'in'};
    }else{
      delete this.lazyLoadEvent.filters['reservationStatus'];
    }
    this.loadLazy(this.lazyLoadEvent);
  }


 async exportPDF(): Promise<void> {
    if (!this.housekeepingReports?.length) {
      this.alertService.warn('No data to export');
      return;
    }

    this.isPrintMode = true;
    this.exportLoading = true;
    this.cdr.detectChanges();

    await new Promise(r => setTimeout(r, 80));

    try {
      const tableWrapper =
        document.querySelector('.p-datatable-wrapper') as HTMLElement ||
        document.querySelector('.p-datatable') as HTMLElement;
      if (!tableWrapper) throw new Error('Table element not found');

      const canvas   = await this.captureCanvas(tableWrapper);
      const pdfBlob  = await this.buildPdf(canvas);
      const filename = `Housekeeping-Report-${moment().format('YYYY-MM-DD')}.pdf`;
      this.downloadBlob(pdfBlob, filename);

      this.messageService.add({
        severity: 'success',
        summary: 'PDF Downloaded',
        detail: 'Your housekeeping report has been downloaded.',
        life: 4000,
      });
    } catch (err: any) {
      console.error('PDF export failed', err);
      this.alertService.error('Failed to generate PDF: ' + (err.message || err));
    } finally {
      this.isPrintMode = false;
      this.exportLoading = false;
      this.cdr.detectChanges();
    }
  }

  private async captureCanvas(element: HTMLElement): Promise<HTMLCanvasElement> {
    const prev = {
      overflow:  element.style.overflow,
      height:    element.style.height,
      maxHeight: element.style.maxHeight,
    };
    element.style.overflow  = 'visible';
    element.style.height    = 'auto';
    element.style.maxHeight = 'none';

    const canvas = await html2canvas(element, {
      scale:        1.5,
      useCORS:      true,
      logging:      false,
      backgroundColor: '#ffffff',
      scrollX:      0,
      scrollY:      -window.scrollY,
      windowWidth:  Math.max(element.scrollWidth, document.documentElement.clientWidth),
      windowHeight: element.scrollHeight,
    });

    element.style.overflow  = prev.overflow;
    element.style.height    = prev.height;
    element.style.maxHeight = prev.maxHeight;
    return canvas;
  }

  private async buildPdf(src: HTMLCanvasElement): Promise<Blob> {
    const PAGE_W   = 792;          // letter landscape width  (pts)
    const PAGE_H   = 612;          // letter landscape height (pts)
    const MARGIN   = 20;           // pts on every side
    const contentW = PAGE_W - MARGIN * 2;   // 752 pts
    const contentH = PAGE_H - MARGIN * 2;   // 572 pts

    // Pts-per-canvas-pixel: keep the image as wide as the content area
    const pxToPt   = contentW / src.width;

    // How many canvas rows fit inside one page's content height?
    const pagePixH = Math.ceil(contentH / pxToPt);

    const totalPages   = Math.ceil(src.height / pagePixH);
    const jpegBuffers: ArrayBuffer[] = [];

    for (let i = 0; i < totalPages; i++) {
      const startY = i * pagePixH;
      const sliceH = Math.min(pagePixH, src.height - startY);

      // Offscreen canvas for this page slice
      const pg  = document.createElement('canvas');
      pg.width  = src.width;
      pg.height = sliceH;
      const ctx = pg.getContext('2d')!;
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, pg.width, pg.height);
      ctx.drawImage(src, 0, startY, src.width, sliceH, 0, 0, src.width, sliceH);

      // Async JPEG encode — does not block the UI thread
      const blob = await new Promise<Blob>((res, rej) =>
        pg.toBlob(b => b ? res(b) : rej(new Error('toBlob failed')), 'image/jpeg', 0.92)
      );
      jpegBuffers.push(await blob.arrayBuffer());
    }

    return this.assemblePdf(jpegBuffers, PAGE_W, PAGE_H, MARGIN, contentW);
  }

  private assemblePdf(
    pages: ArrayBuffer[],
    pageW: number,
    pageH: number,
    margin: number,
    contentW: number,
  ): Blob {
    const enc    = new TextEncoder();
    const chunks: Uint8Array[] = [];
    let   pos    = 0;

    /** Append a UTF-8 string and return its byte length. */
    const w = (s: string): number => {
      const b = enc.encode(s);
      chunks.push(b);
      pos += b.length;
      return b.length;
    };
    /** Append raw binary (e.g. JPEG bytes). */
    const wb = (ab: ArrayBuffer) => {
      const b = new Uint8Array(ab);
      chunks.push(b);
      pos += b.length;
    };

    const n = pages.length;

    const catId   = 1;
    const pagesId = 2;
    const pgBase  = 3;
    const imgBase = pgBase  + n;
    const cntBase = imgBase + n;
    const objCount = cntBase + n;   // total objects including free obj 0

    const offsets = new Array<number>(objCount).fill(0);

    // ── PDF header ───────────────────────────────────────────────────────────
    w('%PDF-1.4\n%\xFF\xFF\xFF\xFF\n');

    // ── 1: Catalog ────────────────────────────────────────────────────────────
    offsets[catId] = pos;
    w(`${catId} 0 obj\n<< /Type /Catalog /Pages ${pagesId} 0 R >>\nendobj\n`);

    // ── 2: Pages tree ─────────────────────────────────────────────────────────
    const kids = Array.from({ length: n }, (_, i) => `${pgBase + i} 0 R`).join(' ');
    offsets[pagesId] = pos;
    w(`${pagesId} 0 obj\n<< /Type /Pages /Kids [${kids}] /Count ${n} >>\nendobj\n`);

    // Parse JPEG dimensions now — needed to compute per-page pt height
    const dims = pages.map(ab => this.parseJpegDimensions(ab));

    // ── Per-page objects ──────────────────────────────────────────────────────
    for (let i = 0; i < n; i++) {
      const pgId  = pgBase  + i;
      const imgId = imgBase + i;
      const cntId = cntBase + i;
      const jpeg  = pages[i];
      const { w: iw, h: ih } = dims[i];
      const name  = `Im${i}`;

      // Actual image height in pts (preserve aspect ratio of this slice)
      const ptH = Math.round(ih * (contentW / iw));

      // Place the image flush with the TOP margin (PDF y-axis: 0 = bottom)
      const yPos = pageH - margin - ptH;
      const stream = `q\n${contentW} 0 0 ${ptH} ${margin} ${yPos} cm\n/${name} Do\nQ\n`;
      const streamLen = enc.encode(stream).length;

      // Page dictionary
      offsets[pgId] = pos;
      w(
        `${pgId} 0 obj\n` +
        `<< /Type /Page /Parent ${pagesId} 0 R\n` +
        `   /MediaBox [0 0 ${pageW} ${pageH}]\n` +
        `   /Resources << /XObject << /${name} ${imgId} 0 R >> >>\n` +
        `   /Contents ${cntId} 0 R >>\nendobj\n`
      );

      // Image XObject (raw JPEG, DCT-decoded by the viewer)
      offsets[imgId] = pos;
      w(
        `${imgId} 0 obj\n` +
        `<< /Type /XObject /Subtype /Image\n` +
        `   /Width ${iw} /Height ${ih}\n` +
        `   /ColorSpace /DeviceRGB /BitsPerComponent 8\n` +
        `   /Filter /DCTDecode /Length ${jpeg.byteLength} >>\nstream\n`
      );
      wb(jpeg);
      w('\nendstream\nendobj\n');

      // Content stream
      offsets[cntId] = pos;
      w(`${cntId} 0 obj\n<< /Length ${streamLen} >>\nstream\n`);
      w(stream);
      w('endstream\nendobj\n');
    }

    // ── Cross-reference table ─────────────────────────────────────────────────
    // Each entry must be exactly 20 bytes: 10-digit-offset SP 5-digit-gen SP f|n SP LF
    const xrefPos = pos;
    w(`xref\n0 ${objCount}\n`);
    w('0000000000 65535 f \n');   // free object 0
    for (let i = 1; i < objCount; i++) {
      w(`${String(offsets[i]).padStart(10, '0')} 00000 n \n`);
    }
    w(`trailer\n<< /Size ${objCount} /Root ${catId} 0 R >>\nstartxref\n${xrefPos}\n%%EOF\n`);

    // Flatten all chunks into a single Uint8Array → Blob
    const totalLen = chunks.reduce((s, c) => s + c.length, 0);
    const out      = new Uint8Array(totalLen);
    let   cursor   = 0;
    for (const c of chunks) { out.set(c, cursor); cursor += c.length; }
    return new Blob([out], { type: 'application/pdf' });
  }

  private parseJpegDimensions(buf: ArrayBuffer): { w: number; h: number } {
    const v = new DataView(buf);
    let i = 2;   // skip SOI marker 0xFF 0xD8
    while (i < v.byteLength - 8) {
      if (v.getUint8(i) !== 0xFF) break;
      const marker = v.getUint8(i + 1);
      const segLen = v.getUint16(i + 2, false);
      // SOF0–SOF3, SOF5–SOF7, SOF9–SOF11, SOF13–SOF15
      if (
        (marker >= 0xC0 && marker <= 0xC3) ||
        (marker >= 0xC5 && marker <= 0xC7) ||
        (marker >= 0xC9 && marker <= 0xCB) ||
        (marker >= 0xCD && marker <= 0xCF)
      ) {
        return {
          h: v.getUint16(i + 5, false),
          w: v.getUint16(i + 7, false),
        };
      }
      i += 2 + segLen;
    }
    return { w: 1, h: 1 };
  }

  private downloadBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const a   = document.createElement('a');
    a.href    = url;
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 2000);
  }

}
